export default __webpack_public_path__ + "static/media/t24.89e78cc0.jpg";